// extracted by mini-css-extract-plugin
export default {"accountHeader":"xs-z","newDesignAccountHeader":"ys-z","primeBadge":"zs-z","logout":"As-z"};